module.exports = __webpack_public_path__ + "img/mikepaper1@2x.ee25f026.jpg";